<rpe-base-table [baseTable]="baseTable" [showActions]="true" [actionMenu]="false"></rpe-base-table>
